import { useState, useEffect } from "react";

import classnames from "classnames";
import { isPresent, capitalize } from "neetocist";
import { globalProps } from "neetocommons/initializers";
import { Button, Typography } from "neetoui";
import Confetti from "react-confetti";
import { useTranslation } from "react-i18next";

import useWindowDimensions from "./hooks/useWindowDimensions.js";

const CompletedScreen = ({
  completeButtonProps,
  completedScreenSuccessMessage,
  className,
}) => {
  const { t } = useTranslation();

  const [dropConfetti, setDropConfetti] = useState(true);
  const { height, width } = useWindowDimensions();

  useEffect(() => {
    const timer = setTimeout(() => setDropConfetti(false), 10000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={classnames("neeto-molecules-onboarding__wrapper", className)}
      data-testid="onboarding-congratulations-wrapper"
    >
      <Confetti {...{ height, width }} recycle={dropConfetti} />
      {isPresent(completedScreenSuccessMessage) ? (
        completedScreenSuccessMessage
      ) : (
        <div className="mx-auto mb-6 flex w-full max-w-2xl flex-col gap-y-2 px-6 pt-16">
          <Typography
            className="text-center"
            data-testid="onboarding-congratulations-emoji"
            style="h1"
          >
            🎉
          </Typography>
          <Typography
            className="text-center"
            data-testid="onboarding-congratulations-title"
            style="h1"
          >
            <span className="neeto-ui-text-success-500">
              {t("neetoMolecules.onboarding.congratulations")}
            </span>
            <br />
            {t("neetoMolecules.onboarding.readyToUse", {
              appName: capitalize(globalProps.appName),
            })}
          </Typography>
        </div>
      )}
      <Button
        data-testid="onboarding-congratulations-button"
        label={t("neetoMolecules.onboarding.helpScreen.startUsingButton", {
          appName: globalProps.appName,
        })}
        {...completeButtonProps}
      />
    </div>
  );
};

export default CompletedScreen;
